<template>
    <div class="scrolling-message-container">
        <div class="scrolling-message">
            <span class="msg">{{ message }}</span>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "ScrollingMessage",
    props: {
        message: {
            type: String,
            required: true,
        },
    },
}
</script>
  
<style scoped>
.scrolling-message-container {
    overflow: hidden;
    white-space: nowrap;
    /* height: 50px; */
    /* 根据需要调整高度 */
    position: relative;
}

.scrolling-message {
    display: inline-block;
    animation: scroll linear infinite;
    animation-duration: 32s;
    /* 可以根据需要调整这里的 duration，使内容滚动的速度更快或更慢 */
    will-change: transform;
    /* 提示浏览器进行性能优化 */
    /* backface-visibility: hidden; */
    /* 分层渲染 */
    /* perspective: 1000px; */
    /* 分层渲染 */
}

@keyframes scroll {
    from {
        transform: translate3d(20%, 0, 0);
    }

    to {
        transform: translate3d(-100%, 0, 0);
    }
}

.msg {
    padding: 0;
    /* 消息之间的间距 */
}
</style>
  